import { useTabLabels } from '@/hooks/useTabLabels';
import { StyledP } from '@/Shared/Typography/typography';

interface CourseUnitsPlaceholderProps {
	isApprovalMode: boolean;
	coursesDraftFocuses: CourseFocusEntity[];
}

const CourseUnitsPlaceholder = ({
	isApprovalMode,
	coursesDraftFocuses,
}: CourseUnitsPlaceholderProps) => {
	const labels = useTabLabels();
	const unitsLabel = labels.units.toLowerCase();

	const renderText = () => {
		let text = '';

		if (
			(isApprovalMode && coursesDraftFocuses) ||
			(isApprovalMode && coursesDraftFocuses && coursesDraftFocuses?.length === 0)
		) {
			text = `No ${unitsLabel} are present.`;
		}

		if (!coursesDraftFocuses || (coursesDraftFocuses && coursesDraftFocuses?.length === 0)) {
			text = `Add the first ${unitsLabel}.`;
		}

		return text;
	};

	if (isApprovalMode) {
		return null;
	}

	if (!renderText()) {
		return null;
	}

	return <StyledP mb="32px">{renderText()}</StyledP>;
};

export default CourseUnitsPlaceholder;
